import { useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Tab } from "@circle-react-uikit/TabV2";
import { BILLING_TABS } from "./billingTabs";

export const PlansTabs = () => {
  const history = useHistory();
  const location = useLocation();

  const activeTab = useMemo(
    () => BILLING_TABS.findIndex(tab => tab.path === location.pathname),
    [location.pathname],
  );

  return (
    <Tab.Group selectedIndex={activeTab}>
      <Tab.ListWrapper className="!px-8">
        <Tab.List>
          {BILLING_TABS.map(({ value, label, path }) => (
            <Tab key={value} onClick={() => history.push(path)}>
              {label}
            </Tab>
          ))}
        </Tab.List>
      </Tab.ListWrapper>
    </Tab.Group>
  );
};
